import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmationMessageDialogData {
  title?: string;
  message?: string;
  confirmLabel?: string;
  confirmResult?: string;
  /** When true, hide Cancel and show only the confirm button (e.g. OK). */
  singleAction?: boolean;
}

@Component({
  selector: 'app-confirmation-message-dialog',
  templateUrl: './confirmation-message-dialog.component.html',
  styleUrls: ['./confirmation-message-dialog.component.scss'],
})
export class ConfirmationMessageDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationMessageDialogData,
    private dialogRef: MatDialogRef<ConfirmationMessageDialogComponent>,
  ) {
    console.log(this.data);
  }

  confirm(): void {
    this.dialogRef.close(this.data.confirmResult ?? 'delete');
  }

  delete(): void {
    this.confirm();
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
